"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;

var _rollupPluginBabelHelpersE84dd01a = require("./_rollupPluginBabelHelpers-e84dd01a.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tinyInvariantEsmA43f84cc = require("./tiny-invariant.esm-a43f84cc.js");

var _constant = require("./constant.js");

var _Provider = require("./Provider.js");

var _utilsB8accee = require("./utils-b8accee6.js");

require("rollbar");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var INITIAL_ERROR_STATE = {
  hasError: false,
  error: null
};

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  (0, _rollupPluginBabelHelpersE84dd01a.b)(ErrorBoundary, _Component);

  var _super = (0, _rollupPluginBabelHelpersE84dd01a.c)(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0, _rollupPluginBabelHelpersE84dd01a.e)(this, ErrorBoundary);
    _this = _super.call(this, props);
    (0, _rollupPluginBabelHelpersE84dd01a._)((0, _rollupPluginBabelHelpersE84dd01a.f)(_this), "resetError", function () {
      _this.setState(INITIAL_ERROR_STATE);
    });
    (0, _tinyInvariantEsmA43f84cc.i)((0, _utilsB8accee.i)(props.level), "".concat(props.level, " is not a valid level setting for Rollbar"));
    _this.state = (0, _rollupPluginBabelHelpersE84dd01a.g)({}, INITIAL_ERROR_STATE);
    return _this;
  }

  (0, _rollupPluginBabelHelpersE84dd01a.d)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var _this$props = this.props,
          errorMessage = _this$props.errorMessage,
          extra = _this$props.extra,
          targetLevel = _this$props.level,
          callback = _this$props.callback;
      var custom = (0, _utilsB8accee.v)(extra, {}, error, info);
      var data = (0, _rollupPluginBabelHelpersE84dd01a.g)((0, _rollupPluginBabelHelpersE84dd01a.g)({}, info), custom);
      var level = (0, _utilsB8accee.v)(targetLevel, _constant.LEVEL_ERROR, error, info);
      var rollbar = (0, _Provider.getRollbarFromContext)(this.context);

      if (!errorMessage) {
        rollbar[level](error, data, callback);
      } else {
        var logMessage = (0, _utilsB8accee.v)(errorMessage, '', error, info);
        rollbar[level](logMessage, error, data, callback);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hasError = _this$state.hasError,
          error = _this$state.error;
      var _this$props2 = this.props,
          fallbackUI = _this$props2.fallbackUI,
          children = _this$props2.children;

      if (!hasError) {
        return children;
      }

      if (!fallbackUI) {
        return null;
      }

      if ( /*#__PURE__*/_react.default.isValidElement(fallbackUI)) {
        return /*#__PURE__*/_react.default.createElement("fallbackUI", {
          error: error,
          resetError: this.resetError
        });
      }

      if (typeof fallbackUI === 'function') {
        var fallbackComponent = fallbackUI(error, this.resetError);
        return /*#__PURE__*/ /*#__PURE__*/_react.default.isValidElement(fallbackComponent) ? fallbackComponent : null;
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        hasError: true,
        error: error
      };
    }
  }]);
  return ErrorBoundary;
}(_react.Component);

exports.ErrorBoundary = ErrorBoundary;
(0, _rollupPluginBabelHelpersE84dd01a._)(ErrorBoundary, "contextType", _Provider.Context);
(0, _rollupPluginBabelHelpersE84dd01a._)(ErrorBoundary, "propTypes", {
  fallbackUI: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  extra: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
  level: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  callback: _propTypes.default.func
});
(0, _rollupPluginBabelHelpersE84dd01a._)(ErrorBoundary, "defaultProps", {
  level: _constant.LEVEL_ERROR
});